// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BotChatInfo__content-c53c73 {
  display: flex;
  flex-direction: column;
  margin-inline-start: 12px;
  justify-content: space-between;
  align-items: flex-start;
  overflow: hidden;
}

.BotChatInfo__title-dd2cd2 {
  font: var(--font-body-1);
  letter-spacing: var(--font-spacing-body-1);
  color: var(--base-110);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.BotChatInfo__bot-d0f495 {
  text-align: left;
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--base-80);
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChatHeader/DefaultHeader/ChatInfo/BotChatInfo/styles.m.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,8BAAA;EACA,uBAAA;EACA,gBAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,sBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,gBAAA;EACA,wBAAA;EACA,0CAAA;EACA,qBAAA;AACF","sourcesContent":[".content {\n  display: flex;\n  flex-direction: column;\n  margin-inline-start: 12px;\n  justify-content: space-between;\n  align-items: flex-start;\n  overflow: hidden;\n}\n\n.title {\n  font: var(--font-body-1);\n  letter-spacing: var(--font-spacing-body-1);\n  color: var(--base-110);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.bot {\n  text-align: left;\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--base-80);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `BotChatInfo__content-c53c73`,
	"title": `BotChatInfo__title-dd2cd2`,
	"bot": `BotChatInfo__bot-d0f495`
};
module.exports = ___CSS_LOADER_EXPORT___;
